import React from "react";
import useTranslationHook from "../../hooks/useTranslationHook";
import { Link } from "react-router-dom";
import moment from "moment";
const Footer = () => {
    const { t } = useTranslationHook();
    const quickLinks = [
        {
            label: "Terms & Conditions",
            url: "/terms-and-condition",
        },
        {
            label: "Privacy Policy",
            url: "/privacy-policy",
        },
        {
            label: "FAQs",
            url: "/faq",
        },
    ];
    return (
        <footer className="footer-small container-fluid">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <div className="links">
                            {quickLinks.map((item, _index) => {
                                return (
                                    <Link key={_index} to={item?.url}>
                                        {t(item.label)}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 text-end">
                        <div className="copyright">
                            {/* ADREC / localization QA #4: this footer hardcoded
                                "© Copyright 2024 HandyHub. All rights reserved." -- an
                                untranslated key with the wrong company and a frozen year.
                                Reuses the "Copyright Label" key the main footer already
                                uses, which carries the approved ADREC text in both
                                languages and interpolates the current year. Original:
                                {t("© Copyright 2024 HandyHub. All rights reserved.")} */}
                            {t("Copyright Label", {
                                dynamicYear: moment()
                                    .locale("en")
                                    .format("YYYY"),
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
